module.exports = __webpack_public_path__ + "static/media/cert_1.46d33008.png";